import * as API from './../base/api_service';
import * as serviceCallConfig from './../config/api_urls';


export var USER_LOGGING_IN = 'USER_LOGGING_IN';
export var USER_LOGGING_DATA = 'USER_LOGGING_DATA';
export var USER_LOGGING_FAILED = 'USER_LOGGING_FAILED';

//export var SECURE = 'QUESTIONS';
export var POSTANSWERS = 'UPDATEANSWERS';
export var OPTIONS = 'Options'

export var FORGOT_USER_NAME = 'FORGOT_USER_NAME';
export var FORGOT_USER_NAME_FAIL = 'FORGOT_USER_NAME_FAIL';
export var FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export var FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
export var GET_SECURITY_QUESTION = ' GET_SECURITY_QUESTION';

export var VERIFY_SECURITY_QUESTION = ' VERIFY_SECURITY_QUESTION';
export var VERIFY_SECURITYQS_FAILD = ' VERIFY_SECURITYQS_FAILD';
export var POSTANSWERS_FAILD = ' POSTANSWERS_FAILD';

// Registration
export var GET_HEIGHEST_DEGREES = 'GET_HEIGHEST_DEGREES';
export var GET_PROFESSIONAL_ROLES = 'GET_PROFESSIONAL_ROLES';
export var GET_ETHNICITIES = 'GET_ETHNICITIES';
export var SET_CURRENT_STAFF_MEMBER = 'SET_CURRENT_STAFF_MEMBER';
export var FILE_UPLOAD_REGISTRATION = 'FILE_UPLOAD_REGISTRATION';

// PATIENT SURVEYRESPONSE DATA

export var PATIENT_SURVEY_RESPONSE_DATA = 'PATIENT_SURVEY_RESPONSE_DATA';

// Staff and Patient search by role
export var USERS_BY_ROLE = 'USERS_BY_ROLE';
// Add Question to Survey
export var ADDQUESTIONSTOSURVEY_DATA = 'ADDQUESTIONSTOSURVEY_DATA';
export var ADDQUESTIONSTOSURVEY = 'ADDQUESTIONSTOSURVEY';

//verify otp

export var VERIFY_OTP = 'VERIFY_OTP'
export var OTP_SUCCESS = 'OTP_SUCCESS'
// GET SURVEY

export var SESSION_LOGOUT = 'SESSION_LOGOUT'; // To store the response of session logout in server.
export var USER_LOG_OUT = 'USER_LOG_OUT'; // To Clear the local store in browser

export var USER_ROLE_ID = 'USER_ROLE_ID';

export var USER_PROFILE_IMAGE = 'USER_PROFILE_IMAGE';

export var SELECTED_CLINIC_NAME = 'SELECTED_CLINIC_NAME';

export var selectedUserRoleID = (data) => ({
    type: USER_ROLE_ID,
    data: data
});
export var FACILIT_CREATED_DATE = 'FACILIT_CREATED_DATE';
export var facilitiCreatedDate = (data) => ({
    type: FACILIT_CREATED_DATE,
    data: data
});

//verify otp
export var verifyOTP = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.VERIFY_OTP),//endPoint
            data,//payLoad
            serviceCallConfig.VERIFY_OTP,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false, //multipart
            getState().User.loginData.data.uniqueKey //uniqueKey
        );
    };
};



export var USER_FACILITY_ID = 'USER_FACILITY_ID';  //used only for admin and satff
export var selectedUserFacilityID = (data) => ({
    type: USER_FACILITY_ID,
    data: data
});

// To Clear the local store in browser
export var user_log_out = (data) => ({
    type: USER_LOG_OUT,
    data: data
});

// logut from current ui
export var SESSION_EXPIRED = 'SESSION_EXPIRED';

export var session_expired = (data) => ({
    type: SESSION_EXPIRED,
    data: data
});
// session logout in Server
export var logout = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.USER_LOG_OUT),//endPoint
            {
                "appType": "WEB",
                "id": getState().User.loginData.data.id,
                "uniqueKey": getState().User.loginData.data.uniqueKey
            },//payLoad
            serviceCallConfig.USER_LOG_OUT,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false, //multipart
            getState().User.loginData.data.uniqueKey //uniqueKey
        );
    };
};

export var userAutoLogout = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.USER_AUTO_LOG_OUT),//endPoint
            data,//payLoad
            serviceCallConfig.USER_AUTO_LOG_OUT,//requestFrom
            false,//isURLEncoded
            '', //authKey
            '',//api_key
            ''//getParams
        );
    };
};

// To set session logout response from server
export var setSessionLogout = (data) => ({
    type: SESSION_LOGOUT,
    data: data
});

export var otpSuccess = (data) => ({
    type: OTP_SUCCESS,
    data: data
});


// GET SURVEY

export var GET_SURVEY_LIST = 'GET_SURVEY_LIST';

export var survey_list_data = (data) => ({
    type: GET_SURVEY_LIST,
    data: data
});


export var get_survey_list = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_SURVEY_LIST),//endPoint
            data,//payLoad
            serviceCallConfig.GET_SURVEY_LIST,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false, //multipart
            getState().User.loginData.data.uniqueKey //uniqueKey
        );

    };
};

// MULTI_FACILITY_REQUEST

export var MULTI_FACILITY_REQUEST = 'MULTI_FACILITY_REQUEST';

export var MultifacilityRequest_data = (data) => ({
    type: MULTI_FACILITY_REQUEST,
    data: data
});



export var MultifacilityRequest = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.MULTI_FACILITY_REQUEST),//endPoint
            '',//payLoad
            serviceCallConfig.MULTI_FACILITY_REQUEST,//requestFrom
            false,//isURLEncoded
            '',//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false, //multipart
            '' //uniqueKey
        );

    };
};
// GET SURVEY

export var FILLTER_PATIENT_BY_DR = 'FILLTER_PATIENT_BY_DR';

export var fillter_patient_data = (data) => ({
    type: FILLTER_PATIENT_BY_DR,
    data: data
});



export var get_fillter_patient = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.FILLTER_PATIENT_BY_DR),//endPoint
            '',//payLoad
            serviceCallConfig.FILLTER_PATIENT_BY_DR,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false, //multipart
            getState().User.loginData.data.uniqueKey //uniqueKey
        );

    };
};


export var getUserName = (data) => ({
    type: FORGOT_USER_NAME,
    data: data
})
export var updateOptions = (data) => {
    return ({
        type: OPTIONS,
        data: data
    })
};


export var getUserNameFail = (data) => ({
    type: FORGOT_USER_NAME_FAIL,
    data: data
});

export var userPasswordDetail = (data) => ({
    type: FORGOT_PASSWORD,
    data: data
});


// export var updateQuestion = (data) => ({
//     type: POSTANSWERS,
//     data: data
// });

// export var updateSQFaildData = (data) => ({
//     type: POSTANSWERS_FAILD,
//     data: data
// })


// Not using - To set previously user selected security questions
// export var getSecurQuesiton = (data) => ({
//     type: GET_SECURITY_QUESTION,
//     data: data
// });


export var otpVerify = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.OTP_VERIFY),
            data,
            serviceCallConfig.OTP_VERIFY,
            false,
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken,


        );

    };
};

export var userLlogin = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.LOGIN),
            data,
            serviceCallConfig.LOGIN,
            false,
            ''
        );
    };
};


export var logingDetails = (data) => ({
    type: USER_LOGGING_DATA,
    data: data
});
export var loginFaild = (data) => {
    return ({
        type: USER_LOGGING_FAILED,
        data: data
    });
};

export var forgotuserName = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.FORGOT_USER_NAME),
            '',
            serviceCallConfig.FORGOT_USER_NAME,
            '', '', '',
            data
        );

    };
};

export var updateQuestions = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.UPDATE_QUESTIONS),
            data
            ,
            '',
            false
        // getState().User.loginData.accessToken
    }
}


export var forgotPasword = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.FORGOT_PASSWORD),
            data,
            serviceCallConfig.FORGOT_PASSWORD,
            false,
            ''
        );

    };
};

//To get user Selected Security questions
export var getSecurityQuestion = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_SECURITY_QUESTION),
            '',
            serviceCallConfig.GET_SECURITY_QUESTION,
            '', '', '',
            data,
            false, //multipart
            getState().User.loginData.data.uniqueKey //uniqueKey
        );

    };
};

// To Verify Security Questions answers while reset passord
export var verifySecurityQuestions = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.VERIFY_SECURITY),
            data,
            serviceCallConfig.VERIFY_SECURITY,
            false,
            '', '', '',
        );
    };
};

// To set success response of -- Verify the answers of User selected Security Questions in Reset Password flow
export var verifyAnswers = (data) => ({
    type: VERIFY_SECURITY_QUESTION,
    data: data
})

// To set failure response of -- Verify the answers of User selected Security Questions in Reset Password flow
export var verifyAnswersFaild = (data) => ({
    type: VERIFY_SECURITYQS_FAILD,
    data: data
})

// questionsUpdate not using
// export var questionsUpdate = (data) => {
//     return (dispatch, getState) => {
//         API.makeServiceCall(
//             serviceCallConfig.API_POST,
//             dispatch,
//             serviceCallConfig.get(serviceCallConfig.UPDATE_QUESTIONS),
//             data
//             ,
//             '',
//             false
//             // getState().User.loginData.accessToken
//         );
//     }
// }

// export var updateQuestion = (data) => ({
//     type: POSTANSWERS,
//     data: data
// })


// Registration
export var highestDegrees = (data) => {

    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_HEIGHEST_DEGREES),
            '',
            serviceCallConfig.GET_HEIGHEST_DEGREES,
            '', '', '',
            data
        );

    };
};
export var get_highestDegrees = (data) => ({
    type: GET_HEIGHEST_DEGREES,
    data: data
});

export var professionalRoles = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_PROFESSIONAL_ROLES),
            '',
            serviceCallConfig.GET_PROFESSIONAL_ROLES,
            '', '', '',
            data
        );

    };
};
export var get_professionalRoles = (data) => ({
    type: GET_PROFESSIONAL_ROLES,
    data: data
});

export var ethnicities = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_GET,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.GET_ETHNICITIES),
            '',
            serviceCallConfig.GET_ETHNICITIES,
            '', '', '',
            data
        );

    };
};
export var get_ethnicities = (data) => ({
    type: GET_ETHNICITIES,
    data: data
});

export var adminDeactivate_data = (data) => ({
    type: VERIFY_SECURITY_QUESTION,
    data: data
})

// Duplicate in this file
// export var verifyAnswersFaild = (data) => ({
//     type: VERIFY_SECURITYQS_FAILD,
//     data: data
// })

// export var currentStaffMember = (data) => {
//     return data
// };

export var setCurrentStaffMember = (data) => ({
    type: SET_CURRENT_STAFF_MEMBER,
    data: data
});



// get doctor list for patient fileter



export var GET_THERAPIST_LIST = 'GET_THERAPIST_LIST';

export var therapist_list_Data = (data) => ({
    type: GET_THERAPIST_LIST,
    data: data
});


export var getTherapistList = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_THERAPIST_LIST),//endPoint
            '',//payLoad
            serviceCallConfig.GET_THERAPIST_LIST,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var GET_PSYCHIATRIST_LIST = 'GET_PSYCHIATRIST_LIST';

export var psychiatrist_list_Data = (data) => ({
    type: GET_PSYCHIATRIST_LIST,
    data: data
});


export var getPsychiatristList = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_PSYCHIATRIST_LIST),//endPoint
            '',//payLoad
            serviceCallConfig.GET_PSYCHIATRIST_LIST,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var USER_TRIGGER_TIME = 'USER_TRIGGER_TIME';

export var user_trigger_time = (data) => ({
    type: USER_TRIGGER_TIME,
    data: data
});



export var setUserTriggerTime = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.USER_TRIGGER_TIME),//endPoint
            data,//payLoad
            serviceCallConfig.USER_TRIGGER_TIME,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

// Patients Registration CSV file upload
export var uploadPatientsRegistrationFile = (fileToUpload, fid, uid) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.UPLOAD_PATIENTS_REGISTRATION_CSV) + '/' + fid + '/' + uid,
            fileToUpload,
            serviceCallConfig.UPLOAD_PATIENTS_REGISTRATION_CSV,
            true, //true for multipart
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            true, //multipart file
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

// Staff Registration CSV file upload
export var uploadStaffRegistrationFile = (fileToUpload, fid, uid) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.UPLOAD_STAFF_REGISTRATION_CSV) + '/' + fid + '/' + uid,
            fileToUpload,
            serviceCallConfig.UPLOAD_STAFF_REGISTRATION_CSV,
            true, //true for multipart
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            true, //multipart file
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

// To set registration file uploaded response
export var setFileUploadRegistration = (data) => ({
    type: FILE_UPLOAD_REGISTRATION,
    data: data
});

// Get Patient Survey Response

export var getPatientSurveryResponse = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.PATIENTS_SURVEY_RESPONSE),//endPoint
            '',//payLoad
            serviceCallConfig.PATIENTS_SURVEY_RESPONSE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};

export var surveyResponseData = (data) => ({
    type: PATIENT_SURVEY_RESPONSE_DATA,
    data: data
});
export var patientsurveyFaildData = (data) => {
    return ({
        type: PATIENT_SURVEY_RESPONSE_DATA,
        data: data
    });
};

// GET_USERS_BY_ROLE
export var setUsersByRole = (data) => ({
    type: USERS_BY_ROLE,
    data: data
});

// To get users by roleid and seach keyword
export var getUsersByRole = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.GET_USERS_BY_ROLE),//endPoint
            data,//payLoad
            serviceCallConfig.GET_USERS_BY_ROLE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


// To ADD QUESTIONS TO SURVEY
export var questionUpdateSurvey = (data) => {
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.ADDQUESTIONSTOSURVEY),//endPoint
            data,//payLoad
            serviceCallConfig.ADDQUESTIONSTOSURVEY,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken, //authKey
            '',//api_key
            '',//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );
    };
};

// To ADD QUESTIONS TO SURVEY DATA
export var addquestionToSurvey_data = (data) => ({
    type: ADDQUESTIONSTOSURVEY_DATA,
    data: data
})

// To ADD QUESTIONS TO SURVEY FAILD DATA
export var addquestionTosurveyFaild_data = (data) => ({
    type: ADDQUESTIONSTOSURVEY_DATA,
    data: data
})
function debug() {

    return true
}
export var AUTO_LOGOUT_TIME = 'AUTO_LOGOUT_TIME';
let time = new Date().getTime();
// To set autoLogOutTime
export var setAutoLogOutTime = (data, getState) => ({

    type: "AUTO_LOGOUT_TIME",
    data: time
})

export var USER_REDFLAG_RESLOVE = 'USER_REDFLAG_RESLOVE';

export var user_redflag_reslove = (data) => ({
    type: USER_REDFLAG_RESLOVE,
    data: data
});



export var resloveRedflags = (data) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_GET,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.USER_REDFLAG_RESLOVE),//endPoint
            '',//payLoad
            serviceCallConfig.USER_REDFLAG_RESLOVE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            data,//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


//DELETE USER
export var USER_DELETE = 'USER_DELETE';

export var user_delete = (data) => ({
    type: USER_DELETE,
    data: data
});

export var deleteUser = (id) => {

    return (dispatch, getState) => {

        API.makeServiceCall(
            serviceCallConfig.API_DELETE,//reqType
            dispatch,//dispatch
            serviceCallConfig.get(serviceCallConfig.USER_DELETE) + '?id=' + id, //endPoint
            '',//payLoad
            serviceCallConfig.USER_DELETE,//requestFrom
            false,//isURLEncoded
            getState().User.loginData.data.accessToken,//authKey   getState().User.loginData.accessToken
            "",//api_key
            "",//getParams
            false,//multipart
            getState().User.loginData.data.uniqueKey, //uniqueKey
        );

    };
};


export var uploadUserProfileImage = (data, type, id) => {
    console.log(serviceCallConfig.USER_PROFILE_IMAGE);
    return (dispatch, getState) => {
        API.makeServiceCall(
            serviceCallConfig.API_POST,
            dispatch,
            serviceCallConfig.get(serviceCallConfig.USER_PROFILE_IMAGE) + "/" + type + "/" + id,
            data,
            serviceCallConfig.USER_PROFILE_IMAGE,
            true, //true for multipart
            false, //authKey
            '',//api_key
            '',//getParams
            true, //multipart file
            "", //uniqueKey

        );

    };
};

// To set uploaded image response
export var upload_User_Profile_Image = (data) => ({
    type: USER_PROFILE_IMAGE,
    data: data
});

export var selectedClinicName = (data) => ({
    type: SELECTED_CLINIC_NAME,
    data: data
});


/** WEBPACK FOOTER **
 ** ./src/actions/user_actions.js
 **/